import styled from "styled-components";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ReactComponent as Logo } from "./logo.svg";

const HeaderElement = styled.header`
  background: rgba(255, 255, 255, 0);
  border-radius: 8px;
  padding: 16px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 9999;
  border: 1px solid rgba(255, 255, 255, 0);
  backdrop-filter: blur(0px);
  -webkit-backdrop-filter: blur(0px);

  > * > svg:hover {
    cursor: pointer;
  }

  ${({ scrolled }) =>
    scrolled &&
    `
            left: 2.5%;
            width: 95%;
            margin-top: 10px;
            border: 1px solid rgba(255, 255, 255, 0.2);
            border-radius: 50px;
            padding: 12px 25px;
            box-shadow: 0 20px 40px rgba(0,0,0,0.1);
            backdrop-filter: blur(20px);

            &:hover {
                transform: translateY(-2px);
                box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.3);
            }
        `}

  > div:first-child {
    margin-right: auto;
  }

  > src {
    cursor: pointer;
  }
`;

const Nav = styled.nav`
  display: flex;
  gap: 2rem;
  align-items: center;

  @media (max-width: 768px) {
    display: none;
  }
`;

const NavLink = styled.a`
  color: #231f1a;
  text-decoration: none;
  font-size: 0.95rem;
  font-weight: 500;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    color: #eb5e28;
    transform: translateY(-1px);
  }
`;

function Header({ onAuthOpen }) {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.pageYOffset > 50);
    handleScroll();

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <HeaderElement scrolled={scrolled}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          margin: 0,
        }}
        onClick={() => {
          window.location.href = "/";
        }}
      >
        <Logo style={{ width: "3rem", height: "auto" }}></Logo>
        <div className="site_name">Smarcuit</div>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: "2rem" }}>
        {location.pathname === "/" && (
          <Nav>
            <NavLink
              href="#why-smarcuit"
              onClick={(e) => {
                e.preventDefault();
                document
                  .getElementById("why-smarcuit")
                  ?.scrollIntoView({ behavior: "smooth" });
              }}
            >
              Why Smarcuit?
            </NavLink>
            <NavLink
              href="#pricing"
              onClick={(e) => {
                e.preventDefault();
                document
                  .getElementById("pricing")
                  ?.scrollIntoView({ behavior: "smooth" });
              }}
            >
              Pricing
            </NavLink>
          </Nav>
        )}
        <button onClick={onAuthOpen}>Get Started</button>
      </div>
    </HeaderElement>
  );
}

export default Header;
